// extracted by mini-css-extract-plugin
export default {"page":"unit-page_page__3Yc4u","content":"unit-page_content__T1cLA"};